export enum DocumentationAreaNotificationTypes {
  UNIDENTIFIED_DOCUMENT = "unidentified_document",
  MODEL_NOT_REQUESTED = "model_not_requested",
  EXPIRED_DOCUMENT = "expired_document",
  ID_NUMBER_DOES_NOT_MATCH = "id_number_does_not_match",
  ID_NUMBER_DOES_NOT_MATCH_FOR_COMPANY = "id_number_does_not_match_for_company",
  MODEL_EXPIRED_VALIDATION_DATA = "model_expired_validation_data",
  PAYSLIP_DUPLICATE_DOCUMENT = "payslip_duplicate_document",
  PAYSLIP_MISSING_ESSENTIAL_DATA = "payslip_missing_essential_data",
  MAX_DOCUMENT_UPLOADS_PER_ACTOR_EXCEEDED = "max_document_uploads_per_actor_exceeded",
  IDENTITY_VERIFICATION_REQUEST_FAILED = "identity_verification_request_failed",
  IDENTITY_VERIFICATION_RESULT_DOES_NOT_MATCH_ID = "identity_verification_result_does_not_match_id_number",
  INVALIDATED_BY_CUSTOMER = "invalidated_by_customer",
  VALIDATED_BY_CUSTOMER = "validated_by_customer",
  MODEL_ADMINISTRATION_UNAVAILABLE = "model_administration_unavailable",
  MODEL_REQUEST_SUCCEEDED = "model_request_succeeded",
  PAYSLIP_REQUEST_SUCCEEDED = "payslip_request_succeeded",
  IDENTITY_VERIFICATION_REQUEST_SUCCEEDED = "identity_verification_request_succeeded",
  OTHER_DOCUMENT_REQUEST_SUCCEEDED = "other_document_request_succeeded",
  MODEL_GENERATED_TOO_LONG_AGO = "model_generated_too_long_ago",
  ORDER_MODEL_ALREADY_HAS_RESPONSE = "order_model_already_has_response",
  PENDING_REVIEW_FROM_ADMIN = "pending_review_from_admin",
  MODEL_GENERIC = "model_generic",
  MODEL_REQUEST_PENDING_EXTRACTION_ASYNC = "model_request_pending_extraction_async",
}

export type DocumentationAreaNotification = {
  id: string;
  type: DocumentationAreaNotificationTypes;
  message: string;
  delivered: boolean;
  messageParams: Record<string, string>;
  createdAt: Date;
};
